<template>
  <tm-gradient-badge
    class="text-uppercase font-size-x-small lh-18"
    :text="text"
    :theme="theme"
  />
</template>

<script setup lang="ts">
import TmGradientBadge from '@/components/shared/badge/TmGradientBadge.vue'
import type { TmGradientBadgeTheme } from '@/components/shared/badge/types'

defineProps<{
  text?: string
  theme?: TmGradientBadgeTheme
}>()
</script>
